import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Button } from 'react-bootstrap';

const PmAssignTicket = ({
  fetchPmTicketAssignee,
  pmTicketAssignee,
  postTicketAssignment,
  match,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [assigneeId, setassigneeId] = useState('');
  const [isModal, setIsModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={() => onAssign()} className="btn btn-primary">
          <img src={Images?.ArrowRight} alt=""></img>
          {localization.assign}
        </Button>
      </Fragment>
    );
  };

  const onAssign = async () => {
    const data = {
      pm_ticket_id: match.params.id,
      assignee_id: assigneeId,
    };
    if (assigneeId !== '') {
      setIsFiled(false);
      const res = await postTicketAssignment(data);
      if (res === true) {
        setIsModal(true);
      } else setIsModal(false);
    } else {
      setIsFiled(true);
    }
  };

  const handleModalHide = () => setIsModal(false);

  useEffect(() => {
    (async () => {
      if (fetchPmTicketAssignee) {
        setIsLoading(true);
        await fetchPmTicketAssignee(match.params.id);
        setIsLoading(false);
      }
    })();
  }, [fetchPmTicketAssignee]);

  return (
    <Layout
      title={localization.assignTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkUrl={`${baseUrl}/pm-tickets`}
    >
      <CardSection title={localization.assignEngineer}>
        <DropDownInput
          label={localization.assignTickets}
          data={pmTicketAssignee}
          required
          isStarRequired={true}
          errorMsg={localization.isRequired}
          getIdValue={(val) => setassigneeId(val.id)}
        />
      </CardSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.assignedSuccessfully}</h5>
          <Link to={`${baseUrl}/pm-tickets`} className="btn btn-primary mb-4">
            {localization.viewPMTickets} <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default PmAssignTicket;
